import { memo, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useIsDesktop } from 'hooks/useIsDesktop';

import { MobileHeader } from './MobileHeader';
import { DesktopHeader } from './DesktopHeader';
import { ContactModal } from './ContactModal';
import { openMenuId } from 'menuState';

export const Header = memo(() => {
  const isDesktop = useIsDesktop();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  const toggleModal = () => setIsModalOpen((value) => !value);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      openMenuId.value = null;
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  return (
    <>
      {isDesktop ? (
        <DesktopHeader openModal={toggleModal} />
      ) : (
        <MobileHeader openModal={toggleModal} />
      )}
      <ContactModal onClose={toggleModal} isOpen={isModalOpen} />
    </>
  );
});
